import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Monkey-patch DOM methods to prevent Radix portal cleanup crashes.
// When React unmounts a Dialog/Select/Popover, the portal nodes may already
// have been removed by Radix internals, causing "removeChild: not a child" errors.
const originalRemoveChild = Node.prototype.removeChild;
Node.prototype.removeChild = function(child) {
  if (child && child.parentNode !== this) {
    return child;
  }
  return originalRemoveChild.call(this, child);
};

const originalInsertBefore = Node.prototype.insertBefore;
Node.prototype.insertBefore = function(newNode, refNode) {
  if (refNode && refNode.parentNode !== this) {
    return newNode;
  }
  return originalInsertBefore.call(this, newNode, refNode);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);
